function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "4BCEB244-B979-4C51-BB04-35B46D879EA3");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "main-desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Dashboard",
  transform: "translate(-1063.000000, -122.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group-7",
  transform: "translate(336.000000, 89.000000)"
}, React.createElement("g", {
  id: "Group-3",
  transform: "translate(712.000000, 21.000000)"
}, React.createElement("g", {
  id: "download-icon",
  transform: "translate(21.000000, 18.000000) rotate(-90.000000) translate(-21.000000, -18.000000) translate(15.500000, 12.000000)"
}, React.createElement("path", {
  d: "M2.682625,5.48470588 L10.3125,5.48470588 C10.6921958,5.48470588 10.9999994,5.80074018 10.9999994,6.19058824 L10.9999994,6.51529412 C10.9999994,6.90514218 10.6921958,7.22117647 10.3125,7.22117647 L2.682625,7.22117647 L5.6629375,10.5169412 C5.9695625,10.8557647 5.9695625,11.4063529 5.6629375,11.7451765 C5.355625,12.0847059 4.8585625,12.0847059 4.55125,11.7451765 L0.4035625,7.15905882 C0.157542634,7.04451051 -0.000342695194,6.79265113 -5.56754008e-07,6.51529412 L-5.56754008e-07,6.18917647 C0.000197143529,5.91233078 0.15799638,5.66116076 0.4035625,5.54682353 L4.55125,0.959294118 C4.8585625,0.620470588 5.355625,0.620470588 5.6629375,0.959294118 C5.9695625,1.29882353 5.9695625,1.84870588 5.6629375,2.18823529 L2.682625,5.48329412 L2.682625,5.48470588 Z",
  id: "addde"
}))))));

var SvgDownloadIcon = function SvgDownloadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownloadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download-icon.d059ea4d.svg";
export { ForwardRef as ReactComponent };